module.exports = __webpack_public_path__ + "static/media/3DPPA31.f9b5c69b.jpg";